import React, { lazy } from 'react';
// Cada tomo tiene su propia imagen — reemplazá una por una
const TOME_01_IMAGE = 'https://cdn.magicpatterns.com/uploads/dRpo5oM2L83gUCTiVQpG5c/hf_20260421_022827_3163a2ca-4b23-4a25-b407-310b96bfe21d.webp';
const TOME_02_IMAGE = 'https://cdn.magicpatterns.com/uploads/218Cvg2UTNVoGfcE6WcD2L/hf_20260421_022934_d07f761b-d7ed-4cae-abf1-1b5ce3ee78bf.webp';
const TOME_03_IMAGE = 'https://cdn.magicpatterns.com/uploads/k1jas4rtAGPLrSk8QG4cEi/hf_20260421_022956_7696c8eb-70c2-4c21-8a12-809e83aa6181.webp';
const TOME_04_IMAGE = 'https://cdn.magicpatterns.com/uploads/w2pfJFecNs3ahbJeLKy4QG/hf_20260421_023017_89baac32-ef71-47dc-8fe5-013b51e60209.webp';
const TOME_05_IMAGE = 'https://cdn.magicpatterns.com/uploads/9i1HYKq7AiQcsT5j7jQ6kR/hf_20260421_023036_1f1d6540-c8df-4f3a-b6f2-ab35fecd48e5.webp';
const TOME_06_IMAGE = 'https://cdn.magicpatterns.com/uploads/8G73So1wd5FBMJURzKyE1a/hf_20260421_023105_f5445997-7dd6-4063-b965-0eea46dd6eab.webp';
const tomes = [{
  label: 'Tomo 01',
  sublabel: 'Encuadre y Admisión',
  image: TOME_01_IMAGE
}, {
  label: 'Tomo 02',
  sublabel: 'Plan Maestro Anual',
  image: TOME_02_IMAGE
}, {
  label: 'Tomo 03',
  sublabel: 'Maletín de Intervenciones',
  image: TOME_03_IMAGE
}, {
  label: 'Tomo 04',
  sublabel: 'Alta Complejidad',
  image: TOME_04_IMAGE
}, {
  label: 'Tomo 05',
  sublabel: 'Gestión y Autocuidado',
  image: TOME_05_IMAGE
}, {
  label: 'Tomo 06',
  sublabel: 'Consultorio Expandido',
  image: TOME_06_IMAGE
}];
const features = ['✅ Criterio clínico profesional en cada sesión', '✅ +360 páginas listas para implementar hoy', '✅ Scripts, plantillas y checklists imprimibles', '✅ Adaptado 100% al psicólogo argentino'];
export function ProductShowcase() {
  return <section className="w-full px-4 lg:px-8 py-10 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 85%, rgb(245,243,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-261">
      <div className="mx-auto max-w-4xl text-center" data-id="element-262">
        {/* Badge */}
        <div className="mb-6 inline-flex items-center gap-2 text-xs font-bold tracking-wide text-violet-700 border border-violet-500/50 bg-violet-500/5 rounded-full px-4 py-1.5" data-id="element-263">
          🏆 El sistema clínico más completo para psicólogos en Argentina
        </div>

        {/* Subtitle */}
        <h3 className="text-xl font-bold text-violet-700 m-0 mb-4" data-id="element-264">
          MEGAPACK PSICOLOGÍA RENTABLE
        </h3>

        {/* Description */}
        <p className="max-w-2xl mx-auto text-gray-800 m-0 mb-8 text-[14px]" data-id="element-265">
          <strong data-id="element-266">6 Tomos + 6 Bonos — Consultorio completo resuelto.</strong>
          <br data-id="element-267" />
          +360 páginas · Protocolo de admisión · Plan maestro anual · Maletín de
          intervenciones · Gestión operativa · Scripts clínicos · Honorarios ·
          Autocuidado. Funciona desde hoy.
        </p>

        {/* Tomes Grid */}
        <div className="relative mx-auto max-w-3xl mb-12" data-id="element-268">
          <div className="grid grid-cols-6 gap-3" data-id="element-269">
            {tomes.map(tome => <div key={tome.label} className="flex flex-col items-center gap-2" data-id="element-270">
                {/* Card con imagen real */}
                <div className="w-full aspect-[3/4] rounded-xl overflow-hidden shadow-lg border border-gray-100" data-id="element-271">
                  <img src={tome.image} alt={`${tome.label} — ${tome.sublabel}`} width={180} height={240} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-272" />
                </div>

                {/* Título separado abajo */}
                <div className="text-center" data-id="element-273">
                  <span className="block text-[11px] sm:text-xs font-black text-gray-900" data-id="element-274">
                    {tome.label}
                  </span>
                  <span className="block text-[9px] sm:text-[10px] text-gray-500 leading-tight mt-0.5" data-id="element-275">
                    {tome.sublabel}
                  </span>
                </div>
              </div>)}
          </div>

          {/* Badge inferior */}
          <div className="mt-6 flex justify-center" data-id="element-276">
            <div className="whitespace-nowrap bg-violet-700 text-[10px] font-black text-white rounded-full px-4 py-1.5 shadow-sm" data-id="element-277">
              6 TOMOS COMPLETOS · +360 PÁGINAS · ACCESO INMEDIATO
            </div>
          </div>
        </div>

        {/* Feature Tags */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto" data-id="element-278">
          {features.map(feature => <div key={feature} className="flex items-center gap-2.5 bg-violet-500/5 border border-violet-500/20 rounded-xl px-4 py-3 text-left" data-id="element-279">
              <span className="flex-shrink-0 w-5 h-5 rounded-full bg-violet-500/15 flex items-center justify-center" data-id="element-280">
                <svg className="w-3 h-3 text-violet-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-281">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-282" />
                </svg>
              </span>
              <span className="text-xs font-semibold text-gray-800 leading-snug" data-id="element-283">
                {feature.replace('✅ ', '')}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}